// אבני בניין משותפות לכל הסכימות.
// כלל: שם zod = שם הטיפוס; camelCase ב-TS וב-wire; ערכי enum ב-snake_case (01 §4).
import { z } from 'zod';

/** uuid (01 §1: `*Id = z.string().uuid()`). */
export const Id = z.uuid();
export type Id = z.infer<typeof Id>;

/** חותמת זמן: Date בזיכרון, ISO string על ה-wire — coerce בשני הכיוונים. */
export const Ts = z.coerce.date();

/** שורת נתונים כללית (תוצאת שאילתה). */
export const Row = z.record(z.string(), z.unknown());
export type Row = z.infer<typeof Row>;

/** jsonb חופשי — מאומת אצל הבעלים לפני כתיבה. */
export const Json = z.unknown();

/** עמודות משותפות לכל טבלה ב-sys (01 §2). */
export const rowBase = {
  id: Id,
  instanceId: Id,
  createdAt: Ts,
  updatedAt: Ts.nullable(),
};

/** מפתח באנגלית: `[a-z][a-z0-9_]*` (עולם, ישות, פריסה, יצירה). */
export const Key = z.string().regex(/^[a-z][a-z0-9_]*$/, 'key must be lower snake_case');

export const Role = z.enum(['admin', 'creator', 'member']);
export type Role = z.infer<typeof Role>;

/** Usage (01) — נרשם על interface_log ועל conversation. */
export const Usage = z.object({
  model: z.string(),
  inputTokens: z.number().int().nonnegative(),
  outputTokens: z.number().int().nonnegative(),
  cacheReadTokens: z.number().int().nonnegative(),
  latencyMs: z.number().nonnegative().optional(),
  costAgorot: z.number().nonnegative(),
  /** 14: ממשקי רשת (web) — בייטים שהתקבלו; מכסת bytesPerDay נמדדת מכאן. */
  bytes: z.number().int().nonnegative().optional(),
});
export type Usage = z.infer<typeof Usage>;
